var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DxCheckBox',{ref:'grid-cb-' + _vm.refKey,attrs:{"on-value-changed":_vm.onSelectionChanged,"element-attr":_vm.checkBoxAttributes,"value":_vm.value,"readOnly":_vm.readOnly,"disabled":_vm.disabled}})
}
var staticRenderFns = []

export { render, staticRenderFns }